import { isSafeText } from './isSafeText'

export const urlify = (text, from) => {
    const { safe, triggers } = isSafeText(text)
    const isSafe = from === 'self' || safe
    
    // // Process the text to convert URLs to clickable links
    // const urlRegex = /(https?:\/\/[^\s]+)/g
    // const processedText = text && text.replace && text.replace(urlRegex, function(url) {
    //     // Make sure the URL itself is also sanitized
    //     const sanitizedUrl = url.replace(/"/g, '&quot;').replace(/'/g, '&#039;')
    //     return '<a href="' + sanitizedUrl + '" target="__blank">' + url + '</a>'
    // }) || ''
    
    // Return both the processed text and a flag indicating if it's safe
    return {
        text,
        isSafe: isSafe,
        triggers
    }
}